import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { Typography } from '@mui/material';
import ChartFilterGroups from '../groups/ChartFilterGroups';
import { groupProp } from '../../../redux/ChartFilterGroup/ChartFilterGroupInterface';

interface Props {
  propKey: string;
  fromDashboard: boolean;
  reportFilterMenu?: boolean;
  setReportFilterMenu?: (value: boolean) => void;
  manualReportFilterMenu?: boolean;
  setManualReportFilterMenu?: (value: boolean) => void;

  color?: string;
  backgroundColor?: string;
}

/**
 * rendered by ChartFilterGroupsContainer.tsx
 * @returns a list of filter group and a text if filter groups are not available.
 */
const ChartFilterList = ({
  propKey,
  fromDashboard,
  reportFilterMenu,
  setReportFilterMenu,
  manualReportFilterMenu,
  setManualReportFilterMenu,
  color,
  backgroundColor,
}: Props) => {
  // name list of selected filter grops in tile
  const [filterGroupNamelist, setFilterGroupNamelist] = useState<string[]>(['No group selected']);
  // name list of selected filter grops in dashboard
  const [dashboardFilterGroupNamelist, setDashboardFilterGroupNamelist] = useState<string[]>([
    'No group selected',
  ]);

  const { chartGroup, dashBoardGroup } = useSelector((state: RootState) => ({
    chartGroup: state.chartFilterGroup,
    dashBoardGroup: state.dashBoardFilterGroup,
  }));

  let selectedFilterGroups: any = fromDashboard
    ? dashBoardGroup.groups
    : chartGroup.tabTile[propKey] || [];
  let showFilters: any[] = [];

  if (selectedFilterGroups && selectedFilterGroups.length > 0) {
    selectedFilterGroups.forEach((grp: string) => {
      showFilters.push({
        id: grp,
        name: chartGroup.groups[grp].name,
        filters: chartGroup.groups[grp].filters,
        isCollapsed: chartGroup.groups[grp].isCollapsed,
        syncFilter: chartGroup.groups[grp].syncFilter,
        dsIdForGroup: chartGroup.groups[grp].dataSetId,
      });
    });
  }

  /* getting names of selected filter groups to store the names in filterGropNamelist 
    state to give it as a value for choose group dropdown when user select or deselect filtergrops in tile */
  useEffect(() => {
    if (chartGroup?.tabTile[propKey]) {
      let temp = chartGroup?.tabTile[propKey].map((el: any) => {
        return chartGroup.groups[el].name;
      });
      if (temp.length === 0) {
        setFilterGroupNamelist(['No group selected']);
      } else {
        setFilterGroupNamelist(temp);
      }
    }
    //eslint-disable-next-line
  }, [chartGroup?.tabTile[propKey]]);

  /* getting names of selected filter group of 'dashboard' to store the names in dashboardFilterGroupNamelist 
    state to give it as a value for choose group dropdown of dashboard when user select or deselect filtergrops in dashboard */
  useEffect(() => {
    if (!chartGroup.groups) return;

    if (dashBoardGroup.groups.length > 0) {
      const selectedDashboardFilterGropsNames = dashBoardGroup.groups.map((el: any) => {
        return chartGroup.groups[el].name;
      });
      setDashboardFilterGroupNamelist(selectedDashboardFilterGropsNames);
    } else {
      setDashboardFilterGroupNamelist(['No group selected']);
    }
    //eslint-disable-next-line
  }, [dashBoardGroup.groups]);

  return (
    <div
      style={{
        padding: '0px 0.5rem 0px 0px',
        width: '99%',
      }}
    >
      {showFilters.length === 0 ? (
        <Typography
          sx={{
            fontSize: '0.75rem',
            padding: '1rem 0',
          }}
        >
          No filter groups selected
        </Typography>
      ) : null}

      {showFilters.map((group: groupProp, indx: number) => (
        <ChartFilterGroups
          key={indx}
          propKey={propKey}
          group={group}
          fromDashboard={fromDashboard}
          reportFilterMenu={reportFilterMenu}
          setReportFilterMenu={setReportFilterMenu}
          manualReportFilterMenu={manualReportFilterMenu}
          setManualReportFilterMenu={setManualReportFilterMenu}
          color={color}
          backgroundColor={backgroundColor}
        ></ChartFilterGroups>
      ))}
    </div>
  );
};

export default ChartFilterList;
